export default function($scope, $stateParams, ApiClass, Swal, eventData, courseData) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.updateEvent = () => {
    const params = buildParams(vm);

    ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event: params })
      .then(({ data: { event } }) => event)
      .then(event => {
        vm.event = { ...vm.event, ...event };
        Swal.toast(`Event updated!`, 'success');
      })
      .catch(error => {
        if (error.message === 'exit') return;
        $log.error(error);
        swal('Error', error, 'error');
        throw error;
      });
  };

  function activate() {
    vm.event = eventData.data.event;
    vm.course = courseData.data.course;
    $scope.$stateParams = $stateParams;
  }
}

function buildParams(vm) {
  const params = {
    event_id: vm.event.event_id,
    course_id: vm.event.course_id,
    access: vm.event.access,
    prep: vm.event.prep,
    blended: vm.event.blended || false
  };

  if (vm.event.delivery_method === 2 || vm.event.delivery_method === 11) {
    params.webinarName = vm.event.webinarName;
    params.url = vm.event.url;
  }

  return params;
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/event/views/addons/index.js